module.exports = __webpack_public_path__ + "static/media/ic-job-security.d672c983.svg";